import { useState } from 'react';
import { Link } from 'react-router-dom';
import useAppDispatch from '../../hooks/use-app-dispatch';
import { authActions } from '../../store/auth';

const Menu: React.FC = (): React.ReactElement => {
  const [showMenuListagem, setShowMenuListagem] = useState(false);
  const [showMobile, setShowMobile] = useState(false);
  const dispatch = useAppDispatch();

  const listarEntidadesHandler = () => {
    setShowMenuListagem(!showMenuListagem);
  };

  const subMenuClickHandler = () => {
    setShowMenuListagem(false);
    setShowMobile(false);
  };

  const sairClickHandler = () => {
    dispatch(authActions.logoff());
  };

  const mobileToggerHandler = () => {
    setShowMobile(!showMobile);
  };

  return (
    <nav className="navbar navbar-expand-lg navbar-light bg-light">
      <div className="container">
        <a className="navbar-brand" href="/">
          MPPB-CNMP
        </a>
        <button className="navbar-toggler" type="button" onClick={mobileToggerHandler}>
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className={`collapse navbar-collapse ${showMobile ? 'show' : ''}`} id="navbarNav">
          <ul className="navbar-nav">
            <li className="nav-item ">
              <Link className="nav-link" to="/home">
                Início
              </Link>
            </li>
            <li className={`nav-item dropdown ${showMenuListagem ? 'show' : ''}`}>
              <Link
                className="nav-link dropdown-toggle"
                to="#"
                id="entidadesDropdownMenuLink"
                onClick={listarEntidadesHandler}
                aria-expanded={showMenuListagem ? true : false}
              >
                Listar entidades
              </Link>
              <div className={`dropdown-menu ${showMenuListagem ? 'show' : ''}`}>
                <Link
                  className={`dropdown-item `}
                  to="/unidades-ministeriais"
                  onClick={subMenuClickHandler}
                >
                  Unidades Ministeriais
                </Link>
                <Link className={`dropdown-item `} to="/membros" onClick={subMenuClickHandler}>
                  Membros
                </Link>
              </div>
            </li>
            <li className="nav-item ">
              <Link className="nav-link" to="/login" onClick={sairClickHandler}>
                Sair
              </Link>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default Menu;
